<template>
  <svg
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Link" transform="translate(-138.000000, -7.000000)" fill="currentColor">
        <g id="Actions-/-Navigation-/-add-/-24" transform="translate(135.000000, 4.000000)">
          <polygon
            id="Fill"
            points="8.5 7.5 8.5 3.5 7.5 3.5 7.5 7.5 3.5 7.5 3.5 8.5 7.5 8.5 7.5 12.5 8.5 12.5 8.5 8.5 12.5 8.5 12.5 7.5"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Plus'
};
</script>
